import React, {Component, PropTypes} from 'react'
import moment from 'moment'
import ReactDayPicker, {DateUtils} from 'react-day-picker'
import localeUtils from 'react-day-picker/moment'

function today() {
    var date = new Date()
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
    return date
}

class DayPicker extends Component {
    static propTypes = {
        value: PropTypes.object,
        onChange: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentWillMount() {
        const {value} = this.props

        this.setState({
            initial: value || new Date()
        })
    }

    _selectDay(day) {
        const {value, onChange} = this.props

        const previousValue = value || today()
        const nextValue = new Date(day.getFullYear(), day.getMonth(), day.getDate(), previousValue.getHours(), previousValue.getMinutes())
        onChange(nextValue)
    }

    render() {
        const {value} = this.props
        const {initial} = this.state

        const modifiers = {
            selected: (day) => DateUtils.isSameDay(day, value),
        }

        const display = (day) => (
            <span>{day.getDate()}</span>
        )

        return (
            <div>
                <ReactDayPicker
                    renderDay={display}
                    modifiers={modifiers}
                    initialMonth={initial}
                    onDayClick={(e, d) => this._selectDay(d)}
                    localeUtils={localeUtils}
                    locale={moment.locale()} />
            </div>
        )
    }
}

export default DayPicker


// WEBPACK FOOTER //
// ./lib/core/components/DayPicker.js